<template>
    <div class="vtext">
        商铺信息详情
    </div>
    <div class="shopdetails">
        <div class="shopleeft">
            <div class="xiaoshou">
                <div class="xiaoshout">
                    <div style="font-size: 16px;color: #111827;">
                        销售额
                    </div>
                    <div class="datachooose">
                        <div class="datain" :class="xiaoe == 1 ? 'datain2' : ''" @click="datachooose(1)">周</div>
                        <div class="datain" :class="xiaoe == 2 ? 'datain2' : ''" @click="datachooose(2)">月</div>
                        <div class="datain" :class="xiaoe == 3 ? 'datain2' : ''" @click="datachooose(3)">年</div>
                    </div>
                </div>

                <div class="echarts-box">
                    <div class="echartsle">
                        <div class="echartsls">
                            <div class="echartslst">
                                <div>净销售额(元)</div>
                                <div><el-icon :size="12">
                                        <Warning />
                                    </el-icon></div>
                            </div>
                            <div class="addyuan">

                                <el-statistic :value="outputValue2" />

                            </div>
                            <div class="baifen"
                                :style="{ 'color': nowfangbaifbi2 - yonghubai2 > 0 ? '#FD6A6A' : '#3F8CFF' }">
                                {{ fangbaifbi2 }}% ({{ (nowfangbaifbi2 - yonghubai2).toFixed(2) }})

                            </div>
                        </div>
                        <div class="echartsls" style="margin-top: 8px;">
                            <div class="echartslst">
                                <div>订单</div>
                                <div><el-icon :size="12">
                                        <Warning />
                                    </el-icon></div>
                            </div>
                            <div class="addyuan">
                                <el-statistic :value="outputValue" />
                            </div>
                            <div class="baifen"
                                :style="{ 'color': nowfangbaifbi3 - yonghubai3 > 0 ? '#FD6A6A' : '#3F8CFF' }">
                                {{ fangbaifbi3 }}% ({{ (nowfangbaifbi3 - yonghubai3).toFixed(2) }})

                            </div>
                        </div>
                    </div>
                    <div id="myEcharts" style="width: 100%;height: 292px;"></div>
                </div>
            </div>
            <div class="fangke">
                <div class="xiaoshout">
                    <div style="font-size: 16px;color: #111827;">
                        访客
                    </div>
                    <div class="datachooose">
                        <div class="datain" :class="fangke == 1 ? 'datain2' : ''" @click="fangkechooose(1)">周</div>
                        <div class="datain" :class="fangke == 2 ? 'datain2' : ''" @click="fangkechooose(2)">月</div>
                        <div class="datain" :class="fangke == 3 ? 'datain2' : ''" @click="fangkechooose(3)">年</div>
                    </div>
                </div>

                <div class="echarts-box">
                    <div class="echartsle">
                        <div class="echartsls">
                            <div class="echartslst">
                                <div>用户</div>
                                <div><el-icon :size="12">
                                        <Warning />
                                    </el-icon></div>
                            </div>
                            <div class="addyuan">

                                <el-statistic :value="outputValue3" />
                            </div>
                            <div class="baifen"
                                :style="{ 'color': nowfangbaifbi - yonghubai > 0 ? '#FD6A6A' : '#3F8CFF' }">
                                {{ fangbaifbi }}% ({{ (nowfangbaifbi - yonghubai).toFixed(2) }})
                            </div>
                        </div>
                    </div>
                    <div id="storeVisitor" style="width: 100%;height: 292px;"></div>
                </div>
            </div>
        </div>
        <div class="shopright">
            <div class="rigtop">店铺信息</div>
            <div class="rigmessage">

                <div class="headerleft">
                    <div class="header">
                        <img style="width: 100%;height: 100%;" :src="images(storeBaseInfo.ucomlogo)" alt="">
                    </div>
                    <div class="megname">
                        <div class="name">
                            <div>{{ storeBaseInfo.ucomname }}</div>
                            <div class="zhuangt">
                                {{ (storeBannedInfo == null || storeBannedInfo.bannedStatus == 0) ? '开店中' : '已封禁' }}
                            </div>
                        </div>
                        <div class="megid">ID: {{ storeBaseInfo.uid }}</div>
                    </div>
                </div>
                <div class="headerright">
                    <div>商铺评价</div>
                    <div class="fen">{{ storeBaseInfo.comprehensiveScore }}<el-icon :size="30">
                            <StarFilled />
                        </el-icon></div>
                </div>
            </div>
            <el-divider />
            <div class="storemsg">

                <div class="msgnone">
                    <div>商铺管理员</div>
                    <div class="meegnumber">{{ storeBaseInfo.ucomcontact }}</div>
                </div>
                <div class="msgnone">
                    <div>商铺保证金</div>
                    <div class="meegnumber">已缴纳</div>
                    <div class="meegnumber">{{ storeBaseInfo.ymoney }}元</div>
                </div>
                <div class="msgnone">
                    <div>商铺类型</div>
                    <div class="meegnumber">{{ storeMarketingInfo.storeIndustry }}</div>
                </div>
            </div>
            <div class="storemsg">

                <div class="msgnone">
                    <div>总销量（件）</div>
                    <div class="meegnumber">{{ storeMarketingInfo.storeProductCount }}</div>
                </div>
                <div class="msgnone">
                    <div>总访客（人）</div>
                    <div class="meegnumber"> {{ storeMarketingInfo.storeViewCount }} </div>

                </div>
                <div class="msgnone">
                    <div>总售额（元）</div>
                    <div class="meegnumber"> {{ storeMarketingInfo.storeSaleAmount }} </div>
                </div>
            </div>
            <div class="storemsg">
                <div class="msgnone">
                    <div>总关注人数（人）</div>
                    <div class="meegnumber">{{ storeMarketingInfo.storeFollowCount }}</div>
                </div>
                <div class="msgnone">
                    <div>总商品（件）</div>

                    <div class="meegnumber">{{ storeMarketingInfo.storeProductCount }}</div>
                </div>
                <div class="msgnone">
                    <div>开店时间</div>
                    <div class="meegnumber">{{ storeBaseInfo.ucomregdate }}</div>
                </div>
            </div>
            <div class="fenjing" @click="changeBannedex(storeBannedInfo)">


                {{ (storeBannedInfo == null || storeBannedInfo.bannedStatus == 0) ? '封禁' : '解封' }}

            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue';
import * as echarts from 'echarts';
import { useRoute, useRouter } from 'vue-router'
import storeapi from '@/api/store'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useTransition } from '@vueuse/core'
const route = useRoute()
const router = useRouter()
const { storeId } = route.query
let storeBaseInfo = ref({})
let storeMarketingInfo = ref({})
let storeBannedInfo = ref({})

const changeBannedex = (storeBannedInfo) => {
    if (storeBannedInfo == null || storeBannedInfo.bannedStatus == 0) {

        ElMessageBox.confirm(
            '是否封禁该店铺?',
            '提示',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }
        )
            .then(() => {
                changeBanned(storeBannedInfo)
            })
            .catch(() => {

            })
    } else {
        ElMessageBox.confirm(
            '是否解封该店铺?',
            '提示',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }
        )
            .then(() => {
                changeBanned(storeBannedInfo)
            })
            .catch(() => {

            })
    }

}

const changeBanned = async (storeBannedInfo) => {
    let bannedStatus
    if (storeBannedInfo == null || storeBannedInfo.bannedStatus == 0) {
        bannedStatus = 1
    } else {
        bannedStatus = 0
    }
    console.log(bannedStatus)
    console.log(storeBannedInfo)
    const res = await storeapi.changeBanned(storeId, bannedStatus)
    console.log(res)
    router.go(0)
}
const images = (face) => {

    if (face) {
        const regex = /"(.*?)"/;
        const result = face.match(regex);
        // 输出提取的字符
        if (result && result[1]) {
            if (result[1].startsWith('http')) {
                return result[1]
            } else {
                if (result[1].startsWith('/')) {
                    return 'http://www.daomenkou.cn' + result[1]

                } else {
                    return 'http://www.daomenkou.cn/' + result[1]

                }
            }
        } else {
            // console.log('未找到匹配的字符串');

            if (face.startsWith('http')) {
                return face
            } else {
                return 'http://www.daomenkou.cn/' + face
            }
        }
    } else {
        return require('../../assets/shop/morentx.png')
    }

}
let xiaolaingdata = []
let storeViewJson = []
const storeInfo = async () => {
    try {
        const res = await storeapi.storeInfo(storeId)
        const storeinfo = res.data
        storeBaseInfo.value = storeinfo.storeBaseInfo
        storeMarketingInfo.value = storeinfo.storeMarketingInfo
        storeBannedInfo.value = storeinfo.storeBannedInfo
        console.log(storeBannedInfo.value)
        const dateString = storeBaseInfo.value.ucomregdate
        const date = new Date(dateString)
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        storeBaseInfo.value.ucomregdate = `${year}年${month}月${day}日`
        xiaolaingdata = res.data.storeMarketingInfo.storeSaleJson
        storeViewJson = res.data.storeMarketingInfo.storeViewJson
        datachooose(1)
        fangkechooose(1)

    } catch {

    }
}

const chartData = ref({
    title: {
        text: ''
    },

    xAxis: {
        data: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    },
    yAxis: {
        position: 'right'
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {// 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        },
        // backgroundColor: "transparent",
    },

    series: [
        {
            name: '销售额',
            type: 'bar',
            data: [0, 0, 0, 0, 0, 0],
            barWidth: 20, //柱状宽度
            itemStyle: {    //柱状颜色和圆角
                color: '#3F8CFF',
                borderRadius: [5, 5, 0, 0], // （顺时针左上，右上，右下，左下）
            },

        }
    ]
});
const myVisitor = ref({
    title: {
        text: ''
    },
    xAxis: {
        data: ['A', 'B', 'C', 'D', 'E']
    },
    yAxis: {
        position: 'right'
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {// 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
        },
        // backgroundColor: "transparent",
    },
    series: [
        {
            name: '访客',
            data: [0, 0, 0, 0, 0],
            type: 'line',

            smooth: true,
            areaStyle: {
                color: '#EBF3FF',
            },

        }
    ]
});
let saleCounts = ref(0)
let saleAmounts = ref(0)
let yonghubai2 = ref(0)
let fangbaifbi2 = ref(0)
let nowfangbaifbi2 = ref(0)

let yonghubai3 = ref(0)
let fangbaifbi3 = ref(0)
let nowfangbaifbi3 = ref(0)
const outputValue = useTransition(saleCounts, {
    duration: 1000,
})
const outputValue2 = useTransition(saleAmounts, {
    duration: 1000,
})
let xiaoe = ref(1)

const datachooose = (nub) => {
    saleCounts.value = 0
    saleAmounts.value = 0
    yonghubai2.value = 0
    fangbaifbi2.value = 0
    nowfangbaifbi2.value = 0
    yonghubai3.value = 0
    fangbaifbi3.value = 0
    nowfangbaifbi3.value = 0
    console.log('xiaolaingdata', xiaolaingdata)



    if (xiaolaingdata.length > 1) {
        let lastdate = xiaolaingdata.slice(-1)
        console.log(lastdate)
        let lastyear = lastdate[0].date.split('-')
        console.log(lastyear)
        chartData.value.title.text = lastyear[0] + '年'

        let yue = []
        for (let a = 0; a < xiaolaingdata.length; a++) {
            // const element = array[a];
            let yueb = xiaolaingdata[a].date.split('-')
            if (lastyear[0] == yueb[0]) {
                yue.push(xiaolaingdata[a])
            }
        }
        if (nub == 1) {
            let zou = xiaolaingdata.slice(-7)
            let slicedArray = xiaolaingdata.slice(-14, -7);
            console.log('xiaolaingdata', zou, slicedArray)
            let week = []
            let saleAmount = []
            for (let a = 0; a < zou.length; a++) {
                week.push(getDayOfWeek(zou[a].date))
                saleAmount.push(zou[a].saleAmount)
            }
            chartData.value.xAxis.data = week
            chartData.value.series[0].data = saleAmount
            console.log('chartData', chartData.value)
            zou.forEach(item => {
                saleAmounts.value += item.saleAmount

                saleCounts.value += item.saleCount
            })
            slicedArray.forEach(item => {
                yonghubai2.value += item.saleAmount
                yonghubai3.value += item.saleCount

            })
            nowfangbaifbi2.value = parseFloat(saleAmounts.value.toFixed(2));
            fangbaifbi2.value = Math.round(((nowfangbaifbi2.value - yonghubai2.value) / yonghubai2.value) * 10000) / 100;

            nowfangbaifbi3.value = parseFloat(saleCounts.value.toFixed(2));
            fangbaifbi3.value = Math.round(((nowfangbaifbi3.value - yonghubai3.value) / yonghubai3.value) * 10000) / 100;

            console.log('金钱统计', saleAmounts.value, yonghubai2.value, fangbaifbi2.value);
            console.log('订单统计', saleCounts.value, yonghubai3.value);

            myChart.setOption(chartData.value);

        }
        if (nub == 2) {

            // console.log(yue)
            yue.forEach(item => {
                saleCounts.value += item.saleCount
                saleAmounts.value += item.saleAmount
            })
            // 保留两位小数
            // saleCounts.value = parseFloat(saleCounts.value.toFixed(2));
            // saleAmounts.value = parseFloat(saleAmounts.value.toFixed(2));
            console.log('统计yue', yue, saleCounts.value, saleAmounts.value)
            const salesByMonth = {};

            const saleCount = {}

            for (const item of yue) {
                const month = Number(item.date.split('-')[1]);
                if (!salesByMonth[month]) {
                    salesByMonth[month] = 0;
                }
                if (!saleCount[month]) {
                    saleCount[month] = 0;
                }
                salesByMonth[month] += item.saleAmount;
                saleCount[month] += item.saleCount;
            }

            const resultArray = [];

            for (const month in salesByMonth) {
                resultArray.push({ month, totalSaleAmount: salesByMonth[month], saleCount: saleCount[month] });
            }


            console.log('resultArray', resultArray, salesByMonth);
            if (resultArray.length > 6) {
                for (let i = 0; i < resultArray.length; i++) {
                    const currentMonth = parseInt(resultArray[i].month);
                    if (currentMonth % 2 === 0) {
                        if (i > 0) {
                            const prevMonthIndex = i - 1;
                            resultArray[prevMonthIndex].totalSaleAmount += resultArray[i].totalSaleAmount;
                        } else {
                            // 如果第一个月份是偶数，则将其销售额移至上一个奇数月份或创建新元素
                            const prevMonthIndex = i - 1;
                            if (prevMonthIndex >= 0) {
                                resultArray[prevMonthIndex].totalSaleAmount += resultArray[i].totalSaleAmount;
                            } else {
                                const newMonth = parseInt(resultArray[i].month) - 1;
                                resultArray.unshift({ month: newMonth.toString(), totalSaleAmount: resultArray[i].totalSaleAmount });
                                i++; // 跳过新插入的元素
                            }
                        }
                    }
                }

                // 移除偶数月份
                const filteredResultArray = resultArray.filter(item => parseInt(item.month) % 2 !== 0);
                resultArray = filteredResultArray
                console.log('resultArray', resultArray);
            }
            const months = [];
            const totalSaleAmounts = [];
            const saleCountss = []

            resultArray.forEach(item => {
                months.push(item.month + '月');
                totalSaleAmounts.push(item.totalSaleAmount.toFixed(2));
                saleCountss.push(item.saleCount.toFixed(2));
            });

            console.log("Months:", months);
            console.log("Total Sale Amounts:", totalSaleAmounts);
            console.log("Total Sale saleCounts:", saleCountss);
            chartData.value.xAxis.data = months
            chartData.value.series[0].data = totalSaleAmounts

            if (months.length == 1) {
                nowfangbaifbi2.value = 0
                yonghubai2.value = 0
                fangbaifbi2.value = 0

                nowfangbaifbi3.value = 0
                yonghubai3.value = 0
                fangbaifbi3.value = 0
            } else {
                nowfangbaifbi2.value = parseFloat(totalSaleAmounts[totalSaleAmounts.length - 1]);
                yonghubai2.value = parseFloat(totalSaleAmounts[totalSaleAmounts.length - 2]);
                const result = parseFloat(nowfangbaifbi2.value - yonghubai2.value) / yonghubai2.value;
                fangbaifbi2.value = parseFloat((result * 100).toFixed(2));

                nowfangbaifbi3.value = parseFloat(saleCountss[saleCountss.length - 1]);
                yonghubai3.value = parseFloat(saleCountss[saleCountss.length - 2]);
                const result3 = parseFloat(nowfangbaifbi3.value - yonghubai3.value) / yonghubai2.value;
                fangbaifbi3.value = parseFloat((result3 * 100).toFixed(2));
            }



            console.log('chartData', nowfangbaifbi3.value, yonghubai3.value, fangbaifbi3.value)
            myChart.setOption(chartData.value);


        }
        if (nub == 3) {


            const salesByMonth = {};

            for (const item of xiaolaingdata) {
                const year = Number(item.date.split('-')[0]);
                if (!salesByMonth[year]) {
                    salesByMonth[year] = 0;
                }
                salesByMonth[year] += item.saleAmount;
            }
            const saleCount = {}

            for (const item of xiaolaingdata) {
                const year = Number(item.date.split('-')[0]);
                if (!saleCount[year]) {
                    saleCount[year] = 0;
                }
                saleCount[year] += item.saleCount;
            }
            console.log(salesByMonth)
            const resultArray = [];

            for (const year in salesByMonth) {
                resultArray.push({ year, totalSaleAmount: salesByMonth[year], saleCount: saleCount[year] });
            }


            if (resultArray.length > 6) {
                resultArray = resultArray.slice(-6)
            }
            console.log(resultArray);

            resultArray.forEach(item => {
                saleCounts.value += item.saleCount
                saleAmounts.value += item.totalSaleAmount
            })
            // // 保留两位小数
            // saleCounts.value = parseFloat(saleCounts.value.toFixed(2));
            // saleAmounts.value = parseFloat(saleAmounts.value.toFixed(2));
            console.log('统计', resultArray, saleCounts.value, saleAmounts.value)
            const year = [];
            const totalSaleAmounts = [];
            const saleCountss = []


            resultArray.forEach(item => {
                year.push(item.year + '年');
                totalSaleAmounts.push(item.totalSaleAmount.toFixed(2));
                saleCountss.push(item.saleCount.toFixed(2));
            });
            chartData.value.xAxis.data = year
            chartData.value.series[0].data = totalSaleAmounts

            if (year.length == 1) {
                nowfangbaifbi2.value = 0
                yonghubai2.value = 0
                fangbaifbi2.value = 0

                nowfangbaifbi3.value = 0
                yonghubai3.value = 0
                fangbaifbi3.value = 0

            } else {
                nowfangbaifbi2.value = parseFloat(totalSaleAmounts[totalSaleAmounts.length - 1]);
                yonghubai2.value = parseFloat(totalSaleAmounts[totalSaleAmounts.length - 2]);
                const result = (nowfangbaifbi2.value - yonghubai2.value) / yonghubai2.value;
                fangbaifbi2.value = parseFloat((result * 100).toFixed(2));

                nowfangbaifbi3.value = parseFloat(saleCountss[saleCountss.length - 1]);
                yonghubai3.value = parseFloat(saleCountss[saleCountss.length - 2]);
                const result3 = (nowfangbaifbi3.value - yonghubai3.value) / yonghubai3.value;
                fangbaifbi3.value = parseFloat((result3 * 100).toFixed(2));
            }



            console.log("fangbaifbi2.value:", fangbaifbi2.value);

            console.log('chartData', chartData.value, nowfangbaifbi2.value, yonghubai2.value, fangbaifbi2.value)
            console.log('chartData', chartData.value)
            myChart.setOption(chartData.value);



        }
    }



    xiaoe.value = nub
}

function getDayOfWeek(dateString) {
    // 将日期字符串转换为 Date 对象
    const date = new Date(dateString);

    // 获取星期几（0 表示星期日，1 表示星期一，以此类推）
    const dayOfWeek = date.getDay();

    // 定义一个数组来存储星期几的文本表示
    const days = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

    // 返回对应的星期几文本
    return days[dayOfWeek];
}

let saleCounts2 = ref(0)
let yonghubai = ref(0)
let fangbaifbi = ref(0)
let nowfangbaifbi = ref(0)
const outputValue3 = useTransition(saleCounts2, {
    duration: 1000,

})

let fangke = ref(1)
const fangkechooose = (nub) => {
    saleCounts2.value = 0
    yonghubai.value = 0
    fangbaifbi.value = 0
    nowfangbaifbi.value = 0

    if (storeViewJson.length > 1) {
        let lastdate = storeViewJson.slice(-1)
        console.log('lastdate', lastdate)
        let lastyear = lastdate[0].date.split('-')
        console.log(lastyear)
        myVisitor.value.title.text = lastyear[0] + '年'
        if (nub == 1) {
            let zou = storeViewJson.slice(-7)
            let slicedArray = storeViewJson.slice(-14, -7);
            console.log('storeViewJson', zou)
            let week = []
            let saleAmount = []
            for (let a = 0; a < zou.length; a++) {
                week.push(getDayOfWeek(zou[a].date))
                saleAmount.push(zou[a].viewCount)
            }
            myVisitor.value.xAxis.data = week
            myVisitor.value.series[0].data = saleAmount
            console.log('myVisitor', myVisitor.value)
            zou.forEach(item => {
                saleCounts2.value += item.viewCount

            })
            slicedArray.forEach(item => {
                yonghubai.value += item.viewCount

            })
            // 保留两位小数
            // saleCounts.value = parseFloat(saleCounts.value.toFixed(2));
            // saleAmounts.value = parseFloat(saleAmounts.value.toFixed(2));
            nowfangbaifbi.value = saleCounts2.value
            fangbaifbi.value = parseFloat((nowfangbaifbi.value - yonghubai.value) / yonghubai.value)

            fangbaifbi.value = parseFloat(fangbaifbi.value.toFixed(2)) * 100;
            console.log('统计', saleCounts2.value, yonghubai.value, fangbaifbi.value)
            storeVisitor.setOption(myVisitor.value);

        }
        if (nub == 2) {

            let yue = []
            for (let a = 0; a < storeViewJson.length; a++) {
                // const element = array[a];
                let yueb = storeViewJson[a].date.split('-')
                if (lastyear[0] == yueb[0]) {
                    yue.push(storeViewJson[a])
                }
            }
            console.log(yue)
            yue.forEach(item => {
                saleCounts2.value += item.viewCount

            })
            // 保留两位小数
            // saleCounts.value = parseFloat(saleCounts.value.toFixed(2));
            // saleAmounts.value = parseFloat(saleAmounts.value.toFixed(2));
            console.log('统计', saleCounts.value, saleAmounts.value)
            const salesByMonth = {};

            for (const item of yue) {
                const month = Number(item.date.split('-')[1]);
                if (!salesByMonth[month]) {
                    salesByMonth[month] = 0;
                }
                salesByMonth[month] += item.viewCount;
            }

            const resultArray = [];

            for (const month in salesByMonth) {
                resultArray.push({ month, totalSaleAmount: salesByMonth[month] });
            }

            // if (resultArray.length == 1) {
            //     if (resultArray[0].month == 1) {

            //     } else {
            //         let data = {
            //             month: resultArray[0].month - 1,
            //             totalSaleAmount: 0.00,
            //             saleCount: 0.00
            //         }
            //         resultArray.push(data)
            //     }

            // }

            console.log(resultArray);
            if (resultArray.length > 6) {
                for (let i = 0; i < resultArray.length; i++) {
                    const currentMonth = parseInt(resultArray[i].month);
                    if (currentMonth % 2 === 0) {
                        if (i > 0) {
                            const prevMonthIndex = i - 1;
                            resultArray[prevMonthIndex].totalSaleAmount += resultArray[i].totalSaleAmount;
                        } else {
                            // 如果第一个月份是偶数，则将其销售额移至上一个奇数月份或创建新元素
                            const prevMonthIndex = i - 1;
                            if (prevMonthIndex >= 0) {
                                resultArray[prevMonthIndex].totalSaleAmount += resultArray[i].totalSaleAmount;
                            } else {
                                const newMonth = parseInt(resultArray[i].month) - 1;
                                resultArray.unshift({ month: newMonth.toString(), totalSaleAmount: resultArray[i].totalSaleAmount });
                                i++; // 跳过新插入的元素
                            }
                        }
                    }
                }

                // 移除偶数月份
                const filteredResultArray = resultArray.filter(item => parseInt(item.month) % 2 !== 0);
                resultArray = filteredResultArray
                console.log(resultArray);
            }

            const months = [];
            const totalSaleAmounts = [];

            resultArray.forEach(item => {
                months.push(item.month + '月');
                totalSaleAmounts.push(item.totalSaleAmount.toFixed(2));
            });





            console.log("Months:", months);
            console.log("Total Sale Amounts:", totalSaleAmounts);
            myVisitor.value.xAxis.data = months
            myVisitor.value.series[0].data = totalSaleAmounts



            if (months.length == 1) {
                yonghubai.value = 0
                nowfangbaifbi.value = 0
                fangbaifbi.value = 0

            } else {
                nowfangbaifbi.value = totalSaleAmounts[totalSaleAmounts.length - 1]
                yonghubai.value = totalSaleAmounts[totalSaleAmounts.length - 2]
                fangbaifbi.value = (nowfangbaifbi.value - yonghubai.value) / yonghubai.value
                fangbaifbi.value = parseFloat(fangbaifbi.value.toFixed(2)) * 100;
            }

            console.log('myVisitor', myVisitor.value, nowfangbaifbi.value, yonghubai.value, fangbaifbi.value)
            storeVisitor.setOption(myVisitor.value);


        }
        if (nub == 3) {


            const salesByMonth = {};

            for (const item of storeViewJson) {
                const year = Number(item.date.split('-')[0]);
                if (!salesByMonth[year]) {
                    salesByMonth[year] = 0;
                }
                salesByMonth[year] += item.viewCount;
            }

            console.log(salesByMonth)
            const resultArray = [];

            for (const year in salesByMonth) {
                resultArray.push({ year, totalSaleAmount: salesByMonth[year] });
            }


            if (resultArray.length > 6) {
                resultArray = resultArray.slice(-6)
            }
            console.log(resultArray);

            resultArray.forEach(item => {
                saleCounts2.value += item.totalSaleAmount

            })
            // // 保留两位小数
            // saleCounts.value = parseFloat(saleCounts.value.toFixed(2));
            // saleAmounts.value = parseFloat(saleAmounts.value.toFixed(2));
            console.log('统计', saleCounts2.value)
            const year = [];
            const totalSaleAmounts = [];

            resultArray.forEach(item => {
                year.push(item.year + '年');
                totalSaleAmounts.push(item.totalSaleAmount.toFixed(2));
            });
            myVisitor.value.xAxis.data = year
            myVisitor.value.series[0].data = totalSaleAmounts
            if (year.length == 1) {
                yonghubai.value = 0
                nowfangbaifbi.value = 0
                fangbaifbi.value = 0

            } else {
                nowfangbaifbi.value = totalSaleAmounts[totalSaleAmounts.length - 1]
                yonghubai.value = totalSaleAmounts[totalSaleAmounts.length - 2]
                fangbaifbi.value = parseFloat((nowfangbaifbi.value - yonghubai.value) / yonghubai.value)
                fangbaifbi.value = parseFloat(fangbaifbi.value.toFixed(2)) * 100;
            }




            console.log('myVisitor', myVisitor.value)
            storeVisitor.setOption(myVisitor.value);



        }
    }
    fangke.value = nub

}
let myChart
let storeVisitor
onMounted(() => {
    storeInfo()

    myChart = echarts.init(document.getElementById('myEcharts'));
    storeVisitor = echarts.init(document.getElementById('storeVisitor'));

    storeVisitor.setOption(myVisitor.value);
    myChart.setOption(chartData.value);
});
</script>

<style lang="scss" scoped>
.vtext {
    height: 50px;
    font-size: 32px;
    font-weight: 400;
    color: #0A1629;
    line-height: 50px;
}

::v-deep .el-statistic__number {
    font-size: 18px;
    font-weight: bold;
    color: #111827;
}

.shopdetails {
    width: 1300px;
    height: calc(100% - 82px);

    border-radius: 16px;
    margin-top: 22px;
    display: flex;



    .shopleeft {
        // color: transparent;
        width: 592px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;


        .xiaoshou {
            width: 100%;
            height: 48%;
            background-color: #fff;
            border-radius: 8px;
            padding: 26px 20px 0 24px;
            box-sizing: border-box;

            .xiaoshout {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .datachooose {
                    display: flex;
                    padding: 2px;
                    background-color: #F9FAFB;
                    cursor: pointer;

                    .datain {
                        width: 42px;
                        height: 20px;
                        background-color: #F9FAFB;
                        font-size: 12px;
                        color: #718096;
                        text-align: center;
                        line-height: 20px;
                    }

                    .datain2 {
                        background: #FFFFFF;
                        border-radius: 4px;
                        color: #3F8CFF;
                        box-shadow: 0px 2px 4px 0px rgba(17, 24, 39, 0.04), 0px 2px 4px 0px rgba(17, 24, 39, 0.04);
                    }

                }

            }

            .echarts-box {
                margin-top: 48px;
                display: flex;

                .echartsle {
                    .echartsls {
                        width: 158px;
                        height: 91px;
                        background: #FAFAFA;
                        border-radius: 4px;
                        padding: 10px 21px 0 12px;
                        box-sizing: border-box;

                        .echartslst {
                            font-size: 10px;
                            display: flex;
                            justify-content: space-between;
                            color: #718096;


                        }

                        .addyuan {
                            font-size: 18px;
                            font-weight: bold;
                            color: #111827;
                            line-height: 27px;
                            margin-top: 10px;
                        }

                        .baifen {
                            font-size: 10px;
                            color: #FD6A6A;
                            line-height: 16px;
                        }
                    }

                }

                #myEcharts {
                    margin-top: -50px;
                }
            }

        }

        .fangke {
            // width: 100%;
            // height: 48%;
            // background-color: #fff;
            // border-radius: 8px;
            // padding: 26px 28px 0 24px;
            // box-sizing: border-box;
            width: 100%;
            height: 48%;
            background-color: #fff;
            border-radius: 8px;
            padding: 26px 28px 0 24px;
            box-sizing: border-box;

            .xiaoshout {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .datachooose {
                    display: flex;
                    padding: 2px;
                    background-color: #F9FAFB;
                    cursor: pointer;

                    .datain {
                        width: 42px;
                        height: 20px;
                        background-color: #F9FAFB;
                        font-size: 12px;
                        color: #718096;
                        text-align: center;
                        line-height: 20px;
                    }

                    .datain2 {
                        background: #FFFFFF;
                        border-radius: 4px;
                        color: #3F8CFF;
                        box-shadow: 0px 2px 4px 0px rgba(17, 24, 39, 0.04), 0px 2px 4px 0px rgba(17, 24, 39, 0.04);
                    }

                }

            }

            .echarts-box {
                margin-top: 48px;
                display: flex;

                .echartsle {
                    .echartsls {
                        width: 158px;
                        height: 91px;
                        background: #FAFAFA;
                        border-radius: 4px;
                        padding: 10px 21px 0 12px;
                        box-sizing: border-box;

                        .echartslst {
                            font-size: 10px;
                            display: flex;
                            justify-content: space-between;
                            color: #718096;


                        }

                        .addyuan {
                            font-size: 18px;
                            font-weight: bold;
                            color: #111827;
                            line-height: 27px;
                            margin-top: 10px;
                        }

                        .baifen {
                            font-size: 10px;
                            color: #FD6A6A;
                            line-height: 16px;
                        }
                    }

                }

                #storeVisitor {
                    margin-top: -50px;
                }
            }

        }
    }

    .shopright {
        width: 582px;
        height: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        padding-top: 20px;
        font-size: 16px;
        font-weight: 400;
        color: #111827;
        box-sizing: border-box;
        margin-left: 48px;

        .rigtop {
            margin-left: 28px;
        }

        .rigmessage {
            width: 90%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;

            .headerleft {
                display: flex;
                align-items: center;

                .header {
                    width: 56px;
                    height: 56px;
                    background-color: grey;
                    border-radius: 8px;
                    margin-right: 16px;
                    overflow: hidden;

                }

                .megname {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    font-size: 16px;
                    font-weight: 400;
                    color: #111827;

                    .name {
                        display: flex;

                        .zhuangt {
                            width: 50px;
                            height: 24px;
                            background: #FFDED2;
                            border-radius: 4px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #FA6400;
                            text-align: center;
                            line-height: 24px;
                            margin-left: 10px;
                        }
                    }
                }

                .megid {
                    font-size: 14px;
                    color: #718096;
                }
            }

            .headerright {
                font-size: 18px;
                font-weight: 400;
                color: #FA6400;

                .fen {
                    font-size: 48px;
                    font-weight: 400;
                    color: #FA6400;
                }
            }

        }

        .storemsg {
            display: flex;
            justify-content: space-around;
            height: 130px;

            .msgnone {
                width: 130px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.88);
                line-height: 40px;

                .meegnumber {

                    font-weight: 600;
                    color: #111827;
                    line-height: 20px;

                }
            }
        }

        .fenjing {

            width: 500px;
            height: 51px;
            border: 2px solid #0091FF;
            font-size: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #0091FF;
            border-radius: 8px;
            text-align: center;
            margin: 0 auto;
            line-height: 51px;
            cursor: pointer;

        }

        .fenjing:hover {
            border: 2px solid #fff;
            background-color: #0091FF;
            color: #fff;

        }

    }



}
</style>